import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Home from "../Home/Home";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import { useForm } from "react-hook-form";
import Alert from '@mui/material/Alert';
import axios from 'axios';
import Backdrop from '@mui/material/Backdrop';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useSelector } from "react-redux";
import {useDispatch} from "react-redux";
import { addActiveEventData, addEventData, setSponsorsList } from '../../store/adminSlice';

const Dashboard = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    let activeEventData = useSelector(state => state.activeEventData);
    let eventData = useSelector(state => state.eventData);
    const sponsorsList = useSelector(state => state.sponsorsList);
    let event = eventData; // Change from array to object
    const [activeEvent, setActiveEvent] = useState(activeEventData);
    const [showForm, setShowForm] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const navigate = useNavigate();
    const [openLoader, setOpenLoader] = React.useState(true);
    const [sponsorList, setSponsorList] = React.useState(sponsorsList);
    let eventId = activeEventData.eventId;
    const [showSponsorForm, setshowSponsorForm] = useState(false);
    const [modifiedSponsorData, setModifiedSponsorData] = useState({});
    const dispatch = useDispatch();
    const hasFetched = useRef(false);

    const {
            register: registerForm1,
            handleSubmit: handleSubmitForm1,
            formState: { errors: errorsForm1 },
            reset: resetForm1
        } = useForm();

    const {
        register: registerForm2,
        handleSubmit: handleSubmitForm2,
        setValue,
        formState: { errors: errorsForm2 },
        reset: resetForm2
    } = useForm();

    const blankSponsorObj = {
        address: "",
        amount: "",
        eventType: "",
        sponsorId: "",
        sponsorName: "",
        status: ""
    }

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        fetchSponsorApi();
        modifiedSponsorDataFunc();
        if (activeEventData.eventId) {
          setOpenLoader(false);
        } else {
          fetch(process.env.REACT_APP_API_URL + "/event/get/latest/active")
            .then((response) => response.json())
            .then((activeData) => {
              if (activeData && activeData.eventId) {
                dispatch(addActiveEventData(activeData));
                activeEventData = activeData;
                setActiveEvent(activeEventData);
                eventId = activeEventData.eventId
                fetch(
                  process.env.REACT_APP_API_URL +
                    "/event/registration/get/summary/" +
                    activeData.eventId
                )
                  .then((response) => response.json())
                  .then((data) => {
                    if (data && data.eventId) {
                      eventData = data;
                      event = eventData;
                      dispatch(addEventData(data));
                      setOpenLoader(false);
                    } else {
                      setOpenLoader(false);
                    }
                  })
                  .catch((error) => {
                    console.error("Error fetching event:", error);
                    setOpenLoader(false);
                  });
              } else {
                setOpenLoader(false);
                //   setActiveEvent(null);
              }
            })
            .catch((error) => {
              console.error("Error fetching event:", error);
              setOpenLoader(false);
            });
        }
      }, [modifiedSponsorData, showSponsorForm, resetForm2]);

      function fetchSponsorApi() {
        if(sponsorsList.length === 0) {
            if(sponsorList.length === 0) {
            if(activeEventData.eventId) {
                setOpenLoader(true);
            }
            fetch(process.env.REACT_APP_API_URL + "/sponsor/get/all")
                .then((response) => response.json())
                .then((sponsorList) => {
                    dispatch(setSponsorsList(sponsorList));
                    if(eventData.id) {
                        setOpenLoader(false);
                    }
                    setSponsorList(sponsorList);
                })
            }
        }
      }

      function modifiedSponsorDataFunc() {
        resetForm2(modifiedSponsorData);
      }

    // const {
    //     register,
    //     formState: { errors },
    //     handleSubmit,
    //     reset
    // } = useForm()


    const onSubmit = (data) => {
        setOpenLoader(true);
        const formData = {...activeEvent, ...data};
        axios.put(process.env.REACT_APP_API_URL + '/event/update', formData)
            .then(response => {
                setActiveEvent(formData);
                setAlertMessage("success");
                setShowForm(false);
                setOpenLoader(false);
            })
            .catch(error => {
                console.error('Error:', error);
                setOpenLoader(false);
                // setMessage('Failed to create event. Please try again.');
            });
    }

    const onSubmitSponsorForm = (data) => {
        setOpenLoader(true);
        data.eventType = Number(data.eventType);
        data.amount = Number(data.amount);
        axios.post(process.env.REACT_APP_API_URL + '/sponsor/create', data)
            .then(response => {
                let index;
                const sponsorListArr = [...sponsorList];
                sponsorListArr.forEach((element,i) => {
                    if(element.sponsorId == response.data.sponsorId) {
                        index = i;
                    }
                });
                if(index !== undefined) {
                    sponsorListArr[index] = {...response.data}
                }
                else {
                    sponsorListArr.push(response.data)
                }
                dispatch(setSponsorsList(sponsorListArr));
                setSponsorList(sponsorListArr);
                setModifiedSponsorData(blankSponsorObj);
                setshowSponsorForm(false);
                setOpenLoader(false);
            })
            .catch(error => {
                console.error('Error:', error);
                setOpenLoader(false);
            });
    }


    const handleDownload = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + "/event/registration/get/all/"+eventId);
            const data = response.data;
            if (!data || data.length === 0) {
                alert("No registrations found to download.");
                return;
            }

            const filteredData = data.map(item => ({
                Name: item.userFullName,
                Email: item.emailId,
                Phone: item.phoneNumber,
                City: item.city,
                'Total Attendees': item.totalHeadCountPerBooking,
                Veg: item.totalVeg,
                'Non-Veg': item.totalNonveg,
                'No of Adult': item.numberOfAdult,
                '6 To 12': item.numberBetween6To12,
                'Below 6': item.numberBelow6,
                'Payment Status': item.paymentStatus,
                'Payment ID': item.orderId,
                'Total Booking Amount': item.totalTicketPrice,
                'Purchased At': item.purchasedAt,
                'Registration Type': item.registrationType
            }));

            const worksheet = XLSX.utils.json_to_sheet(filteredData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Events');

            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'events.xlsx');
        } catch (error) {
            console.error('Download error:', error);
        }
    };

    return (
        <Home>

            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={openLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-xs-12 col-sm-12"> <h1>Welcome, {user?.firstName}</h1> </div>
                    <div className="col-md-9 col-xs-12 col-sm-12 text_align_right">
                        {(user?.userRole === 1 || user?.userRole === 2) && <Button variant="contained" 
                        sx={{ 
                            marginRight: {
                                xs: "0px",  // mobile
                                sm: "20px", // tablet
                                md: "20px"  // desktop
                            },
                            marginLeft: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            },
                            marginTop: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            }
                        }}
                        onClick={() => navigate("/admin-panel")}>UPLOAD IMAGE/VIDEO</Button>}                        
                        <Button variant="contained" 
                        sx={{ 
                            marginRight: {
                                xs: "0px",  // mobile
                                sm: "20px", // tablet
                                md: "20px"  // desktop
                            },
                            marginLeft: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            },
                            marginTop: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            }
                        }} 
                        onClick={() => navigate("/event/create")}>Create Event</Button>
                        {/* <Button variant="contained" style={{ marginRight: "20px" }} onClick={() => navigate("/event/view")}>View Events</Button> */}
                        <Button variant="contained" 
                        sx={{ 
                            marginRight: {
                                xs: "0px",  // mobile
                                sm: "20px", // tablet
                                md: "20px"  // desktop
                            },
                            marginLeft: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            },
                            marginTop: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            }
                        }} 
                        onClick={() => navigate("/admin-login")}>Logout</Button>
                        <Button
                            variant="contained"
                            color="success"
                            sx={{ 
                            marginRight: {
                                xs: "0px",  // mobile
                                sm: "20px", // tablet
                                md: "20px"  // desktop
                            },
                            marginLeft: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            },
                            marginTop: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            }
                        }}
                            onClick={handleDownload}
                        >
                            Download
                        </Button>
                    </div>
                </div>

                {/*{!event && <Stack spacing={2} direction="row" alignItems="center">*/}
                {/*    <CircularProgress size="10rem"/>*/}
                {/*</Stack> }*/}

                { alertMessage && <Stack>
                    {alertMessage === "success" && <Alert variant="filled" severity="success">
                        Event Updated Successfully.
                    </Alert>}
                    {alertMessage === "error" && <Alert variant="filled" severity="error">
                    Event Updated failed.
                    </Alert>}
                </Stack>}

                {(event && activeEvent) &&(
                    <>

                        <div style={{ marginBottom: "20px" }}>
                            <h3>Event Summary</h3>

                            <p>
                                <b>Total Collection:</b> ${event.totalCollection?.toFixed(2)}
                            </p>
                        </div>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><b>Registration Type</b></TableCell>
                                        <TableCell><b>Total Head Count</b></TableCell>
                                        <TableCell><b>Adults (Veg & Non-veg)</b></TableCell>
                                        <TableCell><b>Age 6-12</b></TableCell>
                                        <TableCell><b>Below 6</b></TableCell>
                                        <TableCell><b>Veg</b></TableCell>
                                        <TableCell><b>Non-Veg</b></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>

                                    {activeEvent?.eventCode === 2 ? (
                                        <>
                                            {/* Saturday */}
                                            <TableRow>
                                                <TableCell><b>Saturday</b></TableCell>
                                                <TableCell>{event.saturdayHeadCount}</TableCell>
                                                <TableCell>{event.saturdayAdult}</TableCell>
                                                <TableCell>{event.saturday6To12}</TableCell>
                                                <TableCell>{event.saturdayBelow6}</TableCell>
                                                <TableCell>{event.saturdayVeg}</TableCell>
                                                <TableCell>{event.saturdayNonVeg}</TableCell>
                                            </TableRow>

                                            {/* Sunday */}
                                            <TableRow>
                                                <TableCell><b>Sunday</b></TableCell>
                                                <TableCell>{event.sundayHeadCount}</TableCell>
                                                <TableCell>{event.sundayAdult}</TableCell>
                                                <TableCell>{event.sunday6To12}</TableCell>
                                                <TableCell>{event.sundayBelow6}</TableCell>
                                                <TableCell>{event.sundayVeg}</TableCell>
                                                <TableCell>{event.sundayNonVeg}</TableCell>
                                            </TableRow>

                                            {/* Event Only */}
                                            {activeEvent?.eventOnlyStatus === "A" && (
                                                <TableRow>
                                                    <TableCell><b>Event Only</b></TableCell>
                                                    <TableCell>{event.eventOnlyHeadCount}</TableCell>
                                                    <TableCell>{event.eventOnlyAdult}</TableCell>
                                                    <TableCell>{event.eventOnly6To12}</TableCell>
                                                    <TableCell>{event.eventOnlyBelow6}</TableCell>
                                                    <TableCell>{event.eventOnlyVeg}</TableCell>
                                                    <TableCell>{event.eventOnlyNonVeg}</TableCell>
                                                </TableRow>
                                            )}
                                        </>
                                    ) : (
                                        <TableRow>
                                            <TableCell><b>All Days</b></TableCell>
                                            <TableCell>{event.allDaysHeadCount}</TableCell>
                                            <TableCell>{event.allDaysAdult}</TableCell>
                                            <TableCell>{event.allDays6To12}</TableCell>
                                            <TableCell>{event.allDaysBelow6}</TableCell>
                                            <TableCell>{event.allDaysVeg}</TableCell>
                                            <TableCell>{event.allDaysNonVeg}</TableCell>
                                        </TableRow>
                                    )}

                                </TableBody>

                            </Table>
                        </TableContainer>


                        {/*........................................Event information.......................................*/}

                        <h3 style={{ marginTop: "50px" }}>Event Information</h3>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell> <b> Event ID </b> </TableCell>
                                        <TableCell> <b> Event Name </b ></TableCell>
                                        <TableCell> <b> Event Month </b> </TableCell>
                                        <TableCell><b> Event Year </b> </TableCell>
                                        <TableCell> <b> Event City </b> </TableCell>
                                        <TableCell> <b> Event State </b> </TableCell>
                                        <TableCell> <b> Price Adult </b> </TableCell>
                                        <TableCell> <b> Price Below 6 </b> </TableCell>
                                        <TableCell> </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow
                                        key="summarTableRow"
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell>{activeEvent.eventId}</TableCell>
                                        <TableCell>{activeEvent.eventType}</TableCell>
                                        <TableCell>{activeEvent.eventMonth}</TableCell>
                                        <TableCell>{activeEvent.eventYear}</TableCell>
                                        <TableCell>{activeEvent.eventCity}</TableCell>
                                        <TableCell>{activeEvent.eventState}</TableCell>
                                        <TableCell>{activeEvent.priceAdult}</TableCell>
                                        <TableCell>{activeEvent.priceBelow6}</TableCell>
                                        <TableCell>{!showForm && <Grid size={8} style={{cursor: "pointer"}} onClick={()=> {
                                            setShowForm(true);
                                            setAlertMessage("");
                                        }}>
                                            <EditIcon />
                                        </Grid>}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        { showForm && <form className="form_design four-column-layout">
                            <label>
                                <b> Price Below 6: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.priceBelow6} className={errorsForm1.priceBelow6 ? "error_field" : null}
                                       {...registerForm1("priceBelow6", { required: true })}
                                       aria-invalid={errorsForm1.priceBelow6 ? "true" : "false"}
                                />
                                {errorsForm1.priceBelow6?.type === "required" && (
                                    <p role="alert" className="alert_msg">Price Below 6 required</p>
                                )}
                            </label>

                            <label>
                                <b> Price 6 to 12: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.price6to12} className={errorsForm1.price6to12 ? "error_field" : null}
                                       {...registerForm1("price6to12", { required: true })}
                                       aria-invalid={errorsForm1.price6to12 ? "true" : "false"}
                                />
                                {errorsForm1.price6to12?.type === "required" && (
                                    <p role="alert" className="alert_msg">Price 6 to 12 required</p>
                                )}
                            </label>

                            <label>
                                <b> Price Adult: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.priceAdult} className={errorsForm1.priceAdult ? "error_field" : null}
                                       {...registerForm1("priceAdult", { required: true })}
                                       aria-invalid={errorsForm1.priceAdult ? "true" : "false"}
                                />
                                {errorsForm1.priceAdult?.type === "required" && (
                                    <p role="alert" className="alert_msg">Price adult required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Price Below 6: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.earlybirdPriceBelow6} className={errorsForm1.earlybirdPriceBelow6 ? "error_field" : null}
                                       {...registerForm1("earlybirdPriceBelow6", { required: true })}
                                       aria-invalid={errorsForm1.earlybirdPriceBelow6 ? "true" : "false"}
                                />
                                {errorsForm1.earlybirdPriceBelow6?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Price Below 6 required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Price 6 to 12: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.earlybirdPrice6to12} className={errorsForm1.earlybirdPrice6to12 ? "error_field" : null}
                                       {...registerForm1("earlybirdPrice6to12", { required: true })}
                                       aria-invalid={errorsForm1.earlybirdPrice6to12 ? "true" : "false"}
                                />
                                {errorsForm1.earlybirdPrice6to12?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Price 6 to 12 required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Price Adult: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.earlybirdPriceadult} className={errorsForm1.earlybirdPriceadult ? "error_field" : null}
                                       {...registerForm1("earlybirdPriceadult", { required: true })}
                                       aria-invalid={errorsForm1.earlybirdPriceadult ? "true" : "false"}
                                />
                                {errorsForm1.earlybirdPriceadult?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Price Adult required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Expiry: </b>
                                <br></br>
                                <input type="date" defaultValue={activeEvent.earlybirdExpiry.split("T")[0]} className={errorsForm1.earlybirdExpiry ? "error_field" : null}
                                       {...registerForm1("earlybirdExpiry", { required: true })}
                                       aria-invalid={errorsForm1.earlybirdExpiry ? "true" : "false"}
                                />
                                {errorsForm1.earlybirdExpiry?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Expiry required</p>
                                )}
                            </label>

                            <label>
                                <b> Early Bird Status: </b>
                                <br></br>
                                {/* <input type="text" defaultValue={activeEvent.earlyBirdStatus} className={errorsForm1.earlyBirdStatus ? "error_field" : null}
                                       {...registerForm1("earlyBirdStatus", { required: true })}
                                       aria-invalid={errorsForm1.earlyBirdStatus ? "true" : "false"}
                                />
                                {errorsForm1.earlyBirdStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Status required</p>
                                )} */}
                                <select defaultValue={activeEvent.earlyBirdStatus} className={errorsForm1.earlyBirdStatus ? "error_field" : null}
                                       {...registerForm1("earlyBirdStatus", { required: true })}
                                       aria-invalid={errorsForm1.earlyBirdStatus ? "true" : "false"}
                                >
                                    <option value="A">Active</option>
                                    <option value="I">Inactive</option>

                                </select>
                                {errorsForm1.earlyBirdStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Early Bird Status required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Registration Status: </b>
                                <br></br>
                                {/* <input type="text" defaultValue={activeEvent.registrationStatus} className={errorsForm1.registrationStatus ? "error_field" : null}
                                       {...registerForm1("registrationStatus", { required: true })}
                                       aria-invalid={errorsForm1.registrationStatus ? "true" : "false"}
                                />
                                {errorsForm1.registrationStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Registration Status required</p>
                                )} */}
                                <select defaultValue={activeEvent.registrationStatus} className={errorsForm1.registrationStatus ? "error_field" : null}
                                       {...registerForm1("registrationStatus", { required: true })}
                                       aria-invalid={errorsForm1.registrationStatus ? "true" : "false"}
                                >
                                    <option value="open">Open</option>
                                    <option value="closed">Closed</option>

                                </select>
                                {errorsForm1.registrationStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Registration Status required</p>
                                )}
                            </label>

                            <label>
                                <b> Saturday Only Price Adult: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.saturdayPriceAdult} className={errorsForm1.saturdayPriceAdult ? "error_field" : null}
                                       {...registerForm1("saturdayPriceAdult", { required: true })}
                                       aria-invalid={errorsForm1.saturdayPriceAdult ? "true" : "false"}
                                />
                                {errorsForm1.saturdayPriceAdult?.type === "required" && (
                                    <p role="alert" className="alert_msg"> Saturday Only Price Adult required</p>
                                )}
                            </label>

                            <label>
                                <b> Saturday Only Price 6To12: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.saturdayPrice6To12} className={errorsForm1.saturdayPrice6To12 ? "error_field" : null}
                                       {...registerForm1("saturdayPrice6To12", { required: true })}
                                       aria-invalid={errorsForm1.saturdayPrice6To12 ? "true" : "false"}
                                />
                                {errorsForm1.saturdayPrice6To12?.type === "required" && (
                                    <p role="alert" className="alert_msg"> Saturday Only Price 6To12 required</p>
                                )}
                            </label>

                            <label>
                                <b> Saturday Only Price below6: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.saturdayPriceBelow6} className={errorsForm1.saturdayPriceBelow6 ? "error_field" : null}
                                       {...registerForm1("saturdayPriceBelow6", { required: true })}
                                       aria-invalid={errorsForm1.saturdayPriceBelow6 ? "true" : "false"}
                                />
                                {errorsForm1.saturdayPriceBelow6?.type === "required" && (
                                    <p role="alert" className="alert_msg"> Saturday Only Price below6 required</p>
                                )}
                            </label>

                            <label>
                                <b> Saturday Only Status: </b>
                                <br></br>
                                <select defaultValue={activeEvent.satOnlyStatus} className={errorsForm1.satOnlyStatus ? "error_field" : null}
                                        {...registerForm1("satOnlyStatus", { required: true })}
                                        aria-invalid={errorsForm1.satOnlyStatus ? "true" : "false"}
                                >
                                    <option value="A">Active</option>
                                    <option value="I">Inactive</option>

                                </select>
                                {errorsForm1.satOnlyStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Saturday Only Status required</p>
                                )}
                            </label>

                            <label>
                                <b> Sunday Only Price Adult: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.sundayPriceAdult} className={errorsForm1.sundayPriceAdult ? "error_field" : null}
                                       {...registerForm1("sundayPriceAdult", { required: true })}
                                       aria-invalid={errorsForm1.sundayPriceAdult ? "true" : "false"}
                                />
                                {errorsForm1.sundayPriceAdult?.type === "required" && (
                                    <p role="alert" className="alert_msg"> Sunday Only Price Adult required</p>
                                )}
                            </label>

                            <label>
                                <b> Sunday Only Price 6To12: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.sundayPrice6To12} className={errorsForm1.sundayPrice6To12 ? "error_field" : null}
                                       {...registerForm1("sundayPrice6To12", { required: true })}
                                       aria-invalid={errorsForm1.sundayPrice6To12 ? "true" : "false"}
                                />
                                {errorsForm1.sundayPrice6To12?.type === "required" && (
                                    <p role="alert" className="alert_msg"> Sunday Only Price 6To12 required</p>
                                )}
                            </label>

                            <label>
                                <b> Sunday Only Price below6: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.sundayPriceBelow6} className={errorsForm1.sundayPriceBelow6 ? "error_field" : null}
                                       {...registerForm1("sundayPriceBelow6", { required: true })}
                                       aria-invalid={errorsForm1.sundayPriceBelow6 ? "true" : "false"}
                                />
                                {errorsForm1.sundayPriceBelow6?.type === "required" && (
                                    <p role="alert" className="alert_msg"> Sunday Only Price below6 required</p>
                                )}
                            </label>

                            <label>
                                <b> Sunday Only Status: </b>
                                <br></br>
                                <select defaultValue={activeEvent.sunOnlyStatus} className={errorsForm1.sunOnlyStatus ? "error_field" : null}
                                        {...registerForm1("sunOnlyStatus", { required: true })}
                                        aria-invalid={errorsForm1.sunOnlyStatus ? "true" : "false"}
                                >
                                    <option value="A">Active</option>
                                    <option value="I">Inactive</option>

                                </select>
                                {errorsForm1.sunOnlyStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Saturday Only Status required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Only Price Adult: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.eventOnlyPriceAdult} className={errorsForm1.eventOnlyPriceAdult ? "error_field" : null}
                                       {...registerForm1("eventOnlyPriceAdult", { required: true })}
                                       aria-invalid={errorsForm1.eventOnlyPriceAdult ? "true" : "false"}
                                />
                                {errorsForm1.eventOnlyPriceAdult?.type === "required" && (
                                    <p role="alert" className="alert_msg"> Event Only Price required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Only Status: </b>
                                <br></br>
                                <select defaultValue={activeEvent.eventOnlyStatus} className={errorsForm1.eventOnlyStatus ? "error_field" : null}
                                        {...registerForm1("eventOnlyStatus", { required: true })}
                                        aria-invalid={errorsForm1.eventOnlyStatus ? "true" : "false"}
                                >
                                    <option value="A">Active</option>
                                    <option value="I">Inactive</option>

                                </select>
                                {errorsForm1.eventOnlyStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Only Status required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Street: </b>
                                <br></br>
                                <input type="text" defaultValue={activeEvent.eventStreet} className={errorsForm1.eventStreet ? "error_field" : null}
                                       {...registerForm1("eventStreet", { required: true })}
                                       aria-invalid={errorsForm1.eventStreet ? "true" : "false"}
                                />
                                {errorsForm1.eventStreet?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Street required</p>
                                )}
                            </label>

                            {/* <label>
                                <b> Event City: </b>
                                <br></br>
                                <input type="text" defaultValue={activeEvent.eventCity} className={errorsForm1.eventCity ? "error_field" : null}
                                       {...registerForm1("eventCity", { required: true })}
                                       aria-invalid={errorsForm1.eventCity ? "true" : "false"}
                                />
                                {errorsForm1.eventCity?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event City required</p>
                                )}
                            </label> */}

                            <label>
                                <b> Event City: </b>
                                <br></br>
                                <input type="text" defaultValue={activeEvent.eventCity} className={errorsForm1.eventCity ? "error_field" : null}
                                       {...registerForm1("eventCity", { required: true })}
                                       aria-invalid={errorsForm1.eventCity ? "true" : "false"}
                                />
                                {errorsForm1.eventCity?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event City required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Zip: </b>
                                <br></br>
                                <input type="number" defaultValue={activeEvent.eventZip} className={errorsForm1.eventZip ? "error_field" : null}
                                       {...registerForm1("eventZip", { required: true })}
                                       aria-invalid={errorsForm1.eventZip ? "true" : "false"}
                                />
                                {errorsForm1.eventZip?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Zip required</p>
                                )}
                            </label>

                            <label>
                                <b> Event State: </b>
                                <br></br>
                                <input type="text" defaultValue={activeEvent.eventState} className={errorsForm1.eventState ? "error_field" : null}
                                       {...registerForm1("eventState", { required: true })}
                                       aria-invalid={errorsForm1.eventState ? "true" : "false"}
                                />
                                {errorsForm1.eventState?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event State required</p>
                                )}
                            </label>
                            <label>
                                <b> Event Venue: </b>
                                <br></br>
                                <input type="text" defaultValue={activeEvent.eventVenue} className={errorsForm1.eventVenue ? "error_field" : null}
                                       {...registerForm1("eventVenue", { required: true })}
                                       aria-invalid={errorsForm1.eventVenue ? "true" : "false"}
                                />
                                {errorsForm1.eventVenue?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Venue required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Status: </b>
                                <br></br>
                                {/* <input type="text" defaultValue={activeEvent.eventStatus} className={errorsForm1.eventStatus ? "error_field" : null}
                                       {...registerForm1("eventStatus", { required: true })}
                                       aria-invalid={errorsForm1.eventStatus ? "true" : "false"}
                                /> */}
                                <select defaultValue={activeEvent.eventStatus} className={errorsForm1.eventStatus ? "error_field" : null}
                                       {...registerForm1("eventStatus", { required: true })}
                                       aria-invalid={errorsForm1.eventStatus ? "true" : "false"}
                                >
                                    <option value="A">Active</option>
                                    <option value="I">Inactive</option>

                                </select>
                                {errorsForm1.eventStatus?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Status required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Expiry: </b>
                                <br></br>
                                <input type="date" defaultValue={activeEvent.eventExpiry.split("T")[0]} className={errorsForm1.eventExpiry ? "error_field" : null}
                                       {...registerForm1("eventExpiry", { required: true })}
                                       aria-invalid={errorsForm1.eventExpiry ? "true" : "false"}
                                />
                                {errorsForm1.eventExpiry?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Expiry required</p>
                                )}
                            </label>

                            <label>
                                <b> Event Start Date: </b>
                                <br></br>
                                <input type="date" defaultValue={activeEvent.eventStartDate.split("T")[0]} className={errorsForm1.eventStartDate ? "error_field" : null}
                                       {...registerForm1("eventStartDate", { required: true })}
                                       aria-invalid={errorsForm1.eventStartDate ? "true" : "false"}
                                />
                                {errorsForm1.eventStartDate?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event Start Date required</p>
                                )}
                            </label>

                            <label>
                                <b> Event End Date: </b>
                                <br></br>
                                <input type="date" defaultValue={activeEvent.eventEndDate.split("T")[0]} className={errorsForm1.eventEndDate ? "error_field" : null}
                                       {...registerForm1("eventEndDate", { required: true })}
                                       aria-invalid={errorsForm1.eventEndDate ? "true" : "false"}
                                />
                                {errorsForm1.eventEndDate?.type === "required" && (
                                    <p role="alert" className="alert_msg">Event End Date required</p>
                                )}
                            </label>
                            <div></div>
                            <Button variant="contained" fullWidth="100%" onClick={()=> {
                                setShowForm(false);
                                resetForm1();
                            }}> Cancel </Button>
                            <Button variant="contained" onClick={handleSubmitForm1(onSubmit)} fullWidth="100%"> Submit </Button>
                            <div></div>
                        </form> }
                    </>
                )}


                {/* .......................sponsor part..................................... */}

                {(sponsorList && sponsorList.length > 0) &&(
                    <>

                        <h3 style={{ marginTop: "50px" }}>
                            <span> Sponsors List </span>
                            <span style={{float:"right"}}> <Button variant="contained"
                            onClick={()=> {
                                hasFetched.current = false;
                                setModifiedSponsorData(blankSponsorObj);
                                setshowSponsorForm(true);
                            }}
                            >Create Sponsor </Button> </span>
                        </h3>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                <TableRow>
                                    <TableCell><b>Name</b></TableCell>
                                    <TableCell><b>Event Name</b></TableCell>
                                    <TableCell><b>Address</b></TableCell>
                                    <TableCell><b>Amount</b></TableCell>
                                    <TableCell><b>Status</b></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {sponsorList.map((sponsor, index) => (
                                    <TableRow
                                    key={sponsor.eventId || index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                    <TableCell>{sponsor.sponsorName}</TableCell>
                                    <TableCell>
                                        {sponsor.eventType === "1" && "Saraswati Pujo"}
                                        {sponsor.eventType === "2" && "Durga Pujo"}
                                        {sponsor.eventType === "3" && "Bengali New Year"}
                                        {sponsor.eventType === "4" && "Summer Picnic"}
                                    </TableCell>
                                    <TableCell>{sponsor.address}</TableCell>
                                    <TableCell>{sponsor.amount}</TableCell>
                                    <TableCell>
                                        {sponsor.status === "A" && "Active"}
                                        {sponsor.status === "I" && "InActive"}
                                        </TableCell>
                                    <TableCell>
                                        {(sponsor.sponsorId !== modifiedSponsorData.sponsorId) && (
                                        <Grid size={8} style={{ cursor: "pointer" }} onClick={() => {
                                            hasFetched.current = false;
                                            setModifiedSponsorData(sponsor);
                                            setshowSponsorForm(true);
                                            setAlertMessage("");
                                        }}>
                                            <EditIcon />
                                        </Grid>
                                        )}
                                    </TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                            </TableContainer>
                            </>
                        )}

                        { showSponsorForm && 
                            <>
                            <form className="form_design four-column-layout">
                                <label style={{display: "none"}}>
                                    <b> Sponsor Id: </b>
                                    <br></br>
                                    <input type="text" disabled className={errorsForm2.sponsorId ? "error_field" : null}
                                        {...registerForm2("sponsorId")}
                                        aria-invalid={errorsForm2.sponsorName ? "true" : "false"}
                                    />
                                </label>
                                <label>
                                    <b> Sponsor Name: </b>
                                    <br></br>
                                    <input type="text" className={errorsForm2.sponsorName ? "error_field" : null}
                                        {...registerForm2("sponsorName", { required: true })}
                                        aria-invalid={errorsForm2.sponsorName ? "true" : "false"}
                                    />
                                    {errorsForm2.sponsorName?.type === "required" && (
                                        <p role="alert" className="alert_msg">Sponsor Name required</p>
                                    )}
                                </label>
                                <label>
                                    <b> Event Type: </b>
                                    <br></br>
                                    <select className={errorsForm2.eventCode ? "error_field" : null}
                                       {...registerForm2("eventCode", { required: true })}
                                       aria-invalid={errorsForm2.eventCode ? "true" : "false"}
                                    >
                                        <option value="">Select an option</option>
                                        <option value="1">SARASWATI PUJO</option>
                                        <option value="2">DURGA PUJO</option>
                                        <option value="3">BENGALI NEW YEAR</option>
                                        <option value="4">SUMMER PICNIC</option>
                                    </select>
                                    {errorsForm2.eventCode?.type === "required" && (
                                        <p role="alert" className="alert_msg">Event Type required</p>
                                    )}
                                </label>
                                <label>
                                    <b> Sponsor Address: </b>
                                    <br></br>
                                    <input type="text" className={errorsForm2.address ? "error_field" : null}
                                        {...registerForm2("address", { required: true })}
                                        aria-invalid={errorsForm2.address ? "true" : "false"}
                                    />
                                    {errorsForm2.address?.type === "required" && (
                                        <p role="alert" className="alert_msg">Sponsor Address required</p>
                                    )}
                                </label>
                                 <label>
                                    <b> Sponsor Amount: </b>
                                    <br></br>
                                    <input type="number" className={errorsForm2.amount ? "error_field" : null}
                                        {...registerForm2("amount", { required: true })}
                                        aria-invalid={errorsForm2.amount ? "true" : "false"}
                                    />
                                    {errorsForm2.amount?.type === "required" && (
                                        <p role="alert" className="alert_msg">Sponsor Amount required</p>
                                    )}
                                </label>
                                <label>
                                    <b> Event Status: </b>
                                    <br></br>
                                    <select className={errorsForm2.status ? "error_field" : null}
                                       {...registerForm2("status", { required: true })}
                                       aria-invalid={errorsForm2.status ? "true" : "false"}
                                    >
                                        <option value="A">Active</option>
                                        <option value="I">Inactive</option>
                                    </select>
                                    {errorsForm2.status?.type === "required" && (
                                        <p role="alert" className="alert_msg">Event Status required</p>
                                    )}
                                </label>
                                <label>
                                    <b> Sponsor Link: </b>
                                    <br></br>
                                    <input type="text" className={errorsForm2.sponsorLink ? "error_field" : null}
                                        {...registerForm2("sponsorLink")}
                                    />
                                </label>
                                <div></div>
                            <div></div>

                            <div></div>
                            <Button variant="contained" fullWidth="100%" 
                            onClick={()=> {
                                hasFetched.current = false;
                                setModifiedSponsorData(blankSponsorObj);
                                setshowSponsorForm(false);
                            }}
                            > Cancel </Button>
                            <Button variant="contained" onClick={handleSubmitForm2(onSubmitSponsorForm)} fullWidth="100%"> Submit </Button>
                            <div></div>
                            </form>
                            </>
                        }

            </div>


        </Home>
    );
};

export default Dashboard;